import React from "react";
import { HelpCircleIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { problemQuestions } from "../../data/content";
export function ProblemSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-303" data-mp="8kjuhcvrmoa7">
      <div className="mx-auto max-w-4xl" data-id="element-304" data-mp="dj4upcb0p7yn">
        <SectionHeading eyebrow="Stop feeling overwhelmed by complex shoulder assessments" title="You know the anatomy. But do you have a clear process for every assessment?" data-id="element-305" data-mp="di26jc52xjmf" />
        <div className="mx-auto mt-8 max-w-3xl space-y-4 text-lg leading-relaxed text-muted" data-id="element-306" data-mp="3jmbwz6ufs86">
          <p data-id="element-307" data-mp="3lt6de8y3ew06">You’ve studied shoulder anatomy, biomechanics, orthopedic special tests, and rehabilitation principles.</p>
          <p data-id="element-308" data-mp="3qs9i1sa5v07m">
            But when a patient presents with shoulder pain, restricted movement, weakness, or symptoms that don’t fit
            the expected pattern, organizing everything into a coherent clinical picture can be challenging.
          </p>
          <p className="font-semibold text-ink" data-id="element-309" data-mp="1nmjl1ycajgpa">You may find yourself asking:</p>
        </div>
        <ul className="mx-auto mt-5 grid max-w-3xl gap-3" data-id="element-310" data-mp="1inoqy08vi5pv">
          {problemQuestions.map(q => <li key={q} className="flex items-start gap-3 rounded-xl bg-brand-light p-4" data-id="element-311" data-mp="1wev0kp5v9jqh">
              <HelpCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-312" data-mp="1sfm8doqh5tx1" />
              <span className="text-base font-semibold leading-snug text-ink md:text-lg" data-id="element-313" data-mp="14q06uummr2lv">{q}</span>
            </li>)}
        </ul>
        <div className="mx-auto mt-8 max-w-3xl space-y-4 text-lg leading-relaxed text-muted" data-id="element-314" data-mp="zryroksbrnfo">
          <p data-id="element-315" data-mp="1dnkb8cfshf0p">
            I created the <strong className="text-ink" data-id="element-316" data-mp="18qtwbsfq0pgv">Shoulder Assessment Blueprint™</strong> to help you approach
            these questions with a more structured educational framework.
          </p>
          <p data-id="element-317" data-mp="2p6mze8pz0h7d">
            Instead of jumping between scattered notes, textbooks, and saved resources, you’ll have a dedicated
            collection covering the initial interview, clinical screening, physical examination, clinical reasoning,
            and educational case studies.
          </p>
        </div>
        <blockquote className="mx-auto mt-10 max-w-3xl rounded-2xl bg-navy p-6 text-center font-display text-lg font-extrabold uppercase leading-snug text-white md:p-8 md:text-2xl" data-id="element-318" data-mp="1qt93jcslcy55">
          The goal isn’t to make every patient fit the same diagnostic category. It’s to help you organize your
          assessment process while adapting your reasoning to each patient’s presentation.
        </blockquote>
        <div className="mt-10" data-id="element-319" data-mp="182rlq39armyk">
          <CtaButton label="I want a clearer shoulder assessment process" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-320" data-mp="181q1b86e5o46" />
        </div>
      </div>
    </section>;
}